export const symbolFormatter = (value, mobile) =>
  value === '?' ? `${value} USD` : mobile ? `$${value}` : `$${value} USD`

export const dollarSymbolFormatter = value =>
  value === '?' ? value : `$${value}`
